import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, mergeProps as _mergeProps, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "page-content" }
const _hoisted_5 = { id: "estateAgencyProfile" }
const _hoisted_6 = {
  id: "estateAgencyProfile-form",
  class: "form",
  autocomplete: "off"
}
const _hoisted_7 = { class: "width-wrap" }
const _hoisted_8 = { class: "form-header" }
const _hoisted_9 = { class: "width-wrap" }
const _hoisted_10 = { class: "form-section has-aside" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-field readonly" }
const _hoisted_13 = { for: "frm-estateAgencyProfileForm_title" }
const _hoisted_14 = { class: "form-field readonly" }
const _hoisted_15 = { for: "frm-estateAgencyProfileForm_city" }
const _hoisted_16 = { class: "form-field readonly" }
const _hoisted_17 = { for: "frm-estateAgencyProfileForm_zip" }
const _hoisted_18 = { class: "form-field readonly" }
const _hoisted_19 = { for: "frm-estateAgencyProfileForm_street" }
const _hoisted_20 = { class: "form-field readonly" }
const _hoisted_21 = { for: "frm-estateAgencyProfileForm_email" }
const _hoisted_22 = { class: "form-field readonly" }
const _hoisted_23 = { for: "frm-estateAgencyProfileForm_website" }
const _hoisted_24 = { class: "form-field readonly" }
const _hoisted_25 = { for: "frm-estateAgencyProfileForm_phoneNumber" }
const _hoisted_26 = {
  key: 0,
  class: "form-field readonly full-width"
}
const _hoisted_27 = { for: "frm-estateAgencyProfileForm_description" }
const _hoisted_28 = { class: "form-section-aside" }
const _hoisted_29 = { class: "form-field" }
const _hoisted_30 = { class: "form-upload-photo" }
const _hoisted_31 = {
  key: 0,
  class: "photo bordered is-preview"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "line-sep" }, null, -1)
const _hoisted_33 = { class: "width-wrap" }
const _hoisted_34 = { class: "form-header" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "form-field readonly" }
const _hoisted_37 = { for: "frm-estateAgencyProfileForm_invoiceCity" }
const _hoisted_38 = { class: "form-field readonly" }
const _hoisted_39 = { for: "frm-estateAgencyProfileForm_invoiceZip" }
const _hoisted_40 = { class: "form-field readonly" }
const _hoisted_41 = { for: "frm-estateAgencyProfileForm_invoiceStreet" }
const _hoisted_42 = { class: "form-field readonly" }
const _hoisted_43 = { for: "frm-estateAgencyProfileForm_idNumber" }
const _hoisted_44 = { class: "form-field readonly" }
const _hoisted_45 = { for: "frm-estateAgencyProfileForm_vatIdNumber" }
const _hoisted_46 = { class: "form-field readonly" }
const _hoisted_47 = { for: "frm-estateAgencyProfileForm_taxIdNumber" }
const _hoisted_48 = { class: "width-wrap" }
const _hoisted_49 = { class: "form-footer" }
const _hoisted_50 = { class: "buttons" }
const _hoisted_51 = { class: "page-header has-button" }
const _hoisted_52 = { class: "width-wrap" }
const _hoisted_53 = { class: "button-bar" }
const _hoisted_54 = { class: "width-wrap" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "width-wrap" }
const _hoisted_58 = { class: "listing__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EstateAgentListItem = _resolveComponent("EstateAgentListItem")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_EstateAgentInsert = _resolveComponent("EstateAgentInsert")!
  const _component_EstateAgentEdit = _resolveComponent("EstateAgentEdit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('EstateAgencyProfile.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('EstateAgencyProfile.form-header')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('EstateAgencyProfile.agency-title')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.title), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('EstateAgencyProfile.city')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.city), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('EstateAgencyProfile.zip')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.zip), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('EstateAgencyProfile.street')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.street), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('EstateAgencyProfile.email')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.email), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('EstateAgencyProfile.website')) + ":", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.website), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('EstateAgencyProfile.phoneNumber')) + ":", 1),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estateAgency.phoneNumbers, (phone, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(phone), 1))
                    }), 128))
                  ])
                ]),
                (_ctx.estateAgency.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('EstateAgencyProfile.description')) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.description), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    (_ctx.estateAgency.logo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createVNode(_component_ResizableImage, {
                            classes: "estate-agency-logo",
                            url: _ctx.estateAgency.logoRelativeUrl,
                            width: 240,
                            height: 135
                          }, null, 8, ["url"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('EstateAgencyProfile.form-header-invoice-data')), 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('EstateAgencyProfile.invoice-city')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.invoiceCity), 1)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('EstateAgencyProfile.invoice-zip')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.invoiceZip), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('EstateAgencyProfile.invoice-street')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.invoiceStreet), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('EstateAgencyProfile.invoice-idnumber')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.idNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('EstateAgencyProfile.invoice-vatidnumber')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.vatIdNumber), 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('EstateAgencyProfile.invoice-taxidnumber')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.estateAgency.taxIdNumber), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_router_link, {
                  to: { name: 'EstateAgencyProfileEdit' },
                  tag: "button",
                  class: "button button--primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('EstateAgencyProfile.button-save')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('EstateAgencyProfile.agents')), 1),
            _createElementVNode("button", {
              class: "button button--primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEstateAgentInsertModal = true))
            }, _toDisplayString(_ctx.$t('EstateAgencyProfile.button-add-agent')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            (!_ctx.isRecordOrderEnabled)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button button--order",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.enableRecordOrder())),
                  disabled: _ctx.isLoading
                }, _toDisplayString(_ctx.$t('EstateAgencyProfile.button-change-order')), 9, _hoisted_55))
              : _createCommentVNode("", true),
            (_ctx.isRecordOrderEnabled)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "button button--secondary button--order",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveRecordOrder())),
                  disabled: _ctx.isLoading
                }, _toDisplayString(_ctx.$t('EstateAgencyProfile.button-save-order')), 9, _hoisted_56))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createVNode(_component_draggable, _mergeProps({
            list: _ctx.estateAgents,
            disabled: !_ctx.isRecordOrderEnabled,
            "item-key": "frontUserId",
            class: "listing listing--grid"
          }, _ctx.dragOptions), {
            item: _withCtx(({ element }) => [
              _createElementVNode("div", _hoisted_58, [
                _createVNode(_component_EstateAgentListItem, {
                  estateAgent: element,
                  onEdit: _ctx.onEstateAgentEdit,
                  class: _normalizeClass({ 'person-card--draggable': _ctx.isRecordOrderEnabled })
                }, null, 8, ["estateAgent", "onEdit", "class"])
              ])
            ]),
            _: 1
          }, 16, ["list", "disabled"])
        ])
      ])
    ]),
    (_ctx.showEstateAgentInsertModal)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#container"
        }, [
          _createVNode(_component_EstateAgentInsert, {
            onInserted: _ctx.onEstateAgentInserted,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showEstateAgentInsertModal = false))
          }, null, 8, ["onInserted"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEstateAgentEditModal)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#container"
        }, [
          _createVNode(_component_EstateAgentEdit, {
            frontUserId: _ctx.editFrontUserId,
            onUpdated: _ctx.onEstateAgentUpdated,
            onDeleted: _ctx.onEstateAgentDeleted,
            onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showEstateAgentEditModal = false))
          }, null, 8, ["frontUserId", "onUpdated", "onDeleted"])
        ]))
      : _createCommentVNode("", true)
  ]))
}